import clsx from 'clsx';
export default function Button({ variant='primary', className, loading, disabled, children, ...props }) {
  return (
    <button
      className={clsx(
        'btn-base min-h-9 max-w-full justify-center whitespace-normal text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50',
        variant === 'primary' && 'bg-accent text-white hover:brightness-110 active:brightness-95',
        variant === 'ghost' && 'bg-surface2 text-zinc-200 hover:bg-zinc-800',
        variant === 'outline' && 'border border-border bg-transparent text-zinc-200 hover:bg-surface2 hover:text-white',
        variant === 'danger' && 'bg-danger/20 text-danger hover:bg-danger/30',
        className,
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <span
          aria-hidden
          className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent"
        />
      )}
      {children}
    </button>
  );
}

